export default "__VITE_ASSET__Cnp822Fg__"